import type { IzziSaleOrder } from '@/domain/izzi';

const SHIPPING_RECEIPT_MISSING_SERIALS_TOOLTIP =
  'Faltan series en la orden (en kits: caja y control).';

export const formatOrderNumberDisplay = (order: IzziSaleOrder): string =>
  order.orderNumber?.trim() || '—';

export const hasCompleteOrderItems = (order: IzziSaleOrder): boolean => {
  if (!order.items || order.items.length === 0) {
    return false;
  }

  return order.items.every(
    (item) => Array.isArray(item.serialNumbers) && item.serialNumbers.length > 0,
  );
};

export const canDownloadShippingReceipt = (order: IzziSaleOrder): boolean =>
  hasCompleteOrderItems(order);

export const getShippingReceiptDisabledTooltip = (order: IzziSaleOrder): string => {
  if (!hasCompleteOrderItems(order)) {
    return SHIPPING_RECEIPT_MISSING_SERIALS_TOOLTIP;
  }

  return '';
};

export const getOrderNumber = (order: IzziSaleOrder): string =>
  order.orderNumber?.trim() || order.customerSo.trim();

export const parseContentDispositionFilename = (
  contentDisposition: string | undefined,
  fallback: string,
): string => {
  if (!contentDisposition) {
    return fallback;
  }

  const match = contentDisposition.match(/filename="?([^";]+)"?/i);
  return match?.[1]?.trim() || fallback;
};

export const mapShippingReceiptError = (message: string, status?: number): string => {
  const normalizedMessage = message.toLowerCase();

  if (
    normalizedMessage.includes('números de serie') ||
    normalizedMessage.includes('numeros de serie') ||
    normalizedMessage.includes('series incompletas')
  ) {
    return SHIPPING_RECEIPT_MISSING_SERIALS_TOOLTIP;
  }

  if (normalizedMessage.includes('fulfilled')) {
    return 'La orden debe estar en estatus Fulfilled';
  }

  if (status === 404 || normalizedMessage.includes('no encontrada')) {
    return 'Orden no encontrada';
  }

  if (message.trim()) {
    return message;
  }

  return 'Error al generar el acuse de envío';
};
